import React from 'react';

const toggleMenu = () => {
  document.getElementById('navbar-default').classList.toggle('hidden');
}

class Nav extends React.Component {
  render() {
    return (
      <nav class="z-50 border-gray-200 bg-stone-900 py-3 sticky top-0 pb-5 shadow-md">
        <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <a href="/" class="flex items-center">
            <img src="/logo.png" class="w-24" alt="" />
          </a>
          <button
            data-collapse-toggle="navbar-default"
            type="button"
            class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 text-gray-400 hover:bg-gray-700 focus:ring-gray-600"
            aria-controls="navbar-default"
            aria-expanded="false"
            onClick={toggleMenu}
          >
            <span class="sr-only">Open main menu</span>
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15" />
            </svg>
          </button>
          <div class="hidden w-full md:block md:w-auto pt-5" id="navbar-default">
            <ul class="flex flex-col md:flex-row bg-stone-900 border border-solid border-2 p-5 md:p-0 md:border-none mt-5 md:mt-0">
              <li class="my-2 md:my-0 text-center">
                <a href="/" class="px-5 pt-2 block cursor-pointer bg-stone-900 text-white link-underline link-underline-black">HOME</a>
              </li>
              <li class="my-2 md:my-0 text-center">
                <a href="#about" class="px-5 pt-2 block cursor-pointer bg-stone-900 text-white link-underline link-underline-black">ABOUT</a>
              </li>
              <li class="my-2 md:my-0 text-center">
                <a href="#services" class="px-5 pt-2 block cursor-pointer bg-stone-900 text-white link-underline link-underline-black">SERVICES</a>
              </li>
              <li class="my-2 md:my-0 text-center">
                <a href="#feedbacks" class="px-5 pt-2 block cursor-pointer bg-stone-900 text-white link-underline link-underline-black">FEEDBACKS</a>
              </li>
              <li class="my-2 md:my-0 text-center">
                <a href="#contact" class="px-5 block cursor-pointer bg-stone-900 text-white">
                  <button class="font-bold rounded-full hover:outline hover:outline-offset-4 px-5 py-2 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 shadow-lg shadow-indigo-500/20 ">CONTACT ME</button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Nav;